import * as React from 'react';

import * as styles from './PaginationContainer.css';

export const PaginationContainer = ({ children }: React.PropsWithChildren) => {
  return (
    <div data-mark="Pagination" data-testid="pagination" className={styles['container']}>
      {children}
    </div>
  );
};
